<i18n>
{
"en": {
  "TAGSCANNER": "Tag Scanner",
  "ERROR": "Error",
  "TAGIDALREADYASSIGNEDTOSOMEONEELSE": "Tag ID already Assigned to someone else!",
  "TAGHASBEENASSIGNED": "Tag has been assigned!",
  "SUCCESS": "Success",
  "TAGHASBEENSUCCESSFULLYDISABLED": "Tag has been successfully disabled!",
  "INFO": "Info",
  "TAGISNOTASSIGNED": "Tag is not assigned!",
  "SCANTAGNOW": "Scan Tag, now!",
  "FAILEDTOSCANTRYAGAIN": "Failed to scan, try again!",
  "TAGID": "Tag ID",
  "DISABLETAG": "Disable Tag",
  "CLICKONCONFIRMTODISABLEASSIGNEDTAG": "Click on confirm to disable assigned tag!",
  "CANCEL": "Cancel",
  "DISABLE": "Disable",
  "RE-SCAN": "Re-scan",
  "CHANGE": "Change",
  "ASSIGNTAG": "Assign Tag",
  "CONFIRM": "Confirm",
  "BASEBETWEEN": "Base between 2 and 36"
},
"ar": {
  "TAGSCANNER": "المسح الإلكتروني للشارة",
  "ERROR": "خطأ",
  "TAGIDALREADYASSIGNEDTOSOMEONEELSE": "الشارة معينة بالفعل لشخص آخر!",
  "TAGHASBEENASSIGNED": "تم تعيين الشارة!",
  "SUCCESS": "نجاح",
  "TAGHASBEENSUCCESSFULLYDISABLED": "تم تعطيل الشارة بنجاح!",
  "INFO": " معلومات",
  "TAGISNOTASSIGNED": "شارة غير معينة ",
  "SCANTAGNOW": "امسح الشارة، الآن!",
  "FAILEDTOSCANTRYAGAIN": "مسح الكتروني فاشل،حاول مرة أخرى!",
  "TAGID": "الشارة الإلكترونية",
  "DISABLETAG": "  تعطيل الشارة الإلكترونية ",
  "CLICKONCONFIRMTODISABLEASSIGNEDTAG": "انقر على تأكيد لتعطيل العلامة المخصصة!",
  "CANCEL": "إلغاء",
  "DISABLE": "تعطيل",
  "RE-SCAN": "امسح الشارة مجددا",
  "CHANGE": "تغيير",
  "ASSIGNTAG": "عين الشارة", 
  "CONFIRM": "تأكد",
  "BASEBETWEEN": "قاعدة بين 2 و36"  
}
}
</i18n>
<template>
    <el-dialog
        :title="$t('TAGSCANNER')"
        :visible.sync="RFID"
        :before-close="closeModal"
        size="tiny">

        <el-alert
            v-if="message==1"
            :title="$t('ERROR')"
            type="warning"
            :description="$t('TAGIDALREADYASSIGNEDTOSOMEONEELSE')"
            show-icon
            :closable="false">
        </el-alert>

        <el-alert
            v-if="message==0"
            :title="$t('SUCCESS')"
            type="success"
            :description="$t('TAGHASBEENASSIGNED')"
            show-icon
            :closable="false">
        </el-alert>

        <el-alert
            v-if="message==3"
            :title="$t('SUCCESS')"
            type="success"
            :description="$t('TAGHASBEENSUCCESSFULLYDISABLED')"
            show-icon
            :closable="false">
        </el-alert>

        <el-alert
            v-if="message==4"
            :title="$t('INFO')"
            type="info"
            :description="$t('TAGISNOTASSIGNED')"
            show-icon
            :closable="false">
        </el-alert>
        <div class="text-center" v-if="message!=0 && message!=3 && message!=4">
            <h1 v-if="scannedRFID=='' && !error" style="font-weight: bold;margin: 0; font-size: 50px" v-text="timer==0 ? $t('SCANTAGNOW') : timer"></h1>
            <h1 v-if="error && message!=1" style="font-weight: bold;margin: 0; font-size: 40px">{{$t('FAILEDTOSCANTRYAGAIN')}}</h1>

            <div v-if="scanning == 0 && scannedRFID!=''">
                <p>
                    <img class="rounded-img" style="width:100px" :src="getAsset(student.ImagePath, 'student')"/><br/>
                <h4>{{_FullName({NameEN: student.FullName_EN, NameAR: student.FullName_AR})}}</h4>
                </p>
                <h3 style="margin: 0">{{$t('TAGID')}}</h3>
                <h1 class="text-uppercase"  style="font-weight: bold;margin: 0; font-size: 50px; text-transform:uppercase"  v-text="base_convert(scannedRFID, 10, 16)"></h1>
            </div>
        </div>
        <el-alert
            v-if="disableTag && student.AssignedTagID!=null"
            :title="$t('DISABLETAG')"
            type="warning"
            :description="$t('CLICKONCONFIRMTODISABLEASSIGNEDTAG')"
            show-icon
            :closable="false">
        </el-alert>

        <span slot="footer" class="dialog-footer" v-if="!saving">
    <el-button v-if="!disableTag || check" @click="closeModal(null)">{{$t('CANCEL')}}</el-button>
      <el-button v-if="disable()" @click="disableTag=!disableTag"  type="danger">{{disableTag ? $t('CANCEL') : $t('DISABLE')}}</el-button>
      <el-button v-if="reScan()"  @click="scanRFID()" type="primary">{{student.AssignedTagID==null ? $t('RE-SCAN') : $t('CHANGE')}}</el-button>
      <el-button v-if="confirmScan()" @click="saveTagID"   type="primary" >{{(student.StudentID==null && !disableTag) ? $t('ASSIGNTAG') : $t('CONFIRM')}}</el-button>
  </span>
    </el-dialog>
</template>

<script>
  export default {
    name: 'ElTagDialog',
    componentName: 'ElTagDialog',
    props: {
      student: {
        type: Object,
        default: function () {
          return {}
        }
      },
      callScan: {
        type: Boolean,
        default: false
      },
      findTag: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        timer: 3,
        port: 55136,
        scannedRFID: '',
        dialogVisible: false,
        RFID: false,
        saving: false,
        message: null,
        scanning: null,
        error: false,
        disableTag: false
      }
    },
    watch: {
      callScan () {
        this.switchLanguage()
        if (this.callScan) return this.scanRFID(this.student)
        if (this.callScan && this.findTag) return this.scanRFID(this.student, this.findTag)
      },
      RFID () {
        this.updateCallScan()
      }
    },
    computed: {
      check () {
        return this.findTag
      }
    },
    methods: {
      closeModal (done) {
        let self = this
        self.RFID = false
        self.timer = 3
        setTimeout(function () {
          self.scannedRFID = ''
          self.message = null
          self.disableTag = self.error = self.saving = false
          self.scanning = 0
        }, 1000)
      },
      reScan () {
        if (this.disableTag) return false
        if (this.error || this.scannedRFID !== '') return true
        if (this.scanning === 1) return false
        if (this.student.AssignedTagID !== null) return true
        if (this.timer === 0 && this.error) return true
        return false
      },
      disable () {
        if (this.student.StudentID === null) return false
        if (this.check) return false
        if (this.student.AssignedTagID !== null && this.student.AssignedTagID === this.scannedRFID) return true
        return false
      },
      scanRFID (item, check = false) {
        if (!this.check) this.check = check
        this.RFID = true
        this.error = false
        this.message = null
        this.timer = 3
        if (item !== undefined) {
          this.student = item
          this.scanning = 0
          if (item.AssignedTagID !== null) {
            this.scannedRFID = item.AssignedTagID
            return
          }
        }
        if (item === undefined) {
          this.scannedRFID = ''
          this.scanning = 1
        } else {
          if (item.AssignedTagID === null) this.scanning = 1
        }
        let self = this
        let timer = setInterval(function () {
          if (self.timer === 1) self.getTagID()
          if (self.timer === 0) return clearInterval(timer)
          self.timer -= 1
        }, 1000)
      },
      confirmScan () {
        if (this.disableTag) return true
        if (this.scannedRFID !== '') {
          if (this.student.AssignedTagID !== this.scannedRFID) return true
        }
        return false
      },
      saveTagID () {
        let self = this
        if (self.disableTag) self.scannedRFID = null
        self.message = null
        self.saving = true
        let postData = {StudentID: self.student.StudentID, AssignedTagID: self.scannedRFID}
        this.$http.post('/student/save_tag', postData)
          .then(function (response) {
            let data = response.data
            self.message = data.message
            self.error = data.error
            if (!self.error) {
              self.student.AssignedTagID = self.scannedRFID
              setTimeout(function () {
                self.closeModal(null)
              }, 1000)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      base_convert (number, from, to) {
        if (number === null) return
        if ((from && to) < 2 || (from && to) > 36) return this.$t('BASEBETWEEN')
        return parseInt(number + '', from).toString(to)
      },
      getTagID () {
        let self = this
        this.$http.get('http://localhost:' + self.port + '/Home/Index')
          .then(function (response) {
            console.log(response.data)
            if (response.data.success === 1) {
              let tagID = self.base_convert(response.data.tag, 16, 10)
              if (!self.check) return self.checkTagID(tagID)
              return self.studentTag(tagID)
            }
          })
          .catch(function (error) {
            console.log(error)
            if (self.scannedRFID !== '') return
            self.error = true
          })
      },
      studentTag (tagID) {
        let self = this
        this.$http.get('/student/tag?AssignedTagID=' + tagID)
          .then(function (response) {
            let data = response.data
            if (!data.error) {
              self.student = data.student
              self.scannedRFID = tagID
              // self.scanning = null
              self.scanning = 0
              self.disableTag = true
              return
            }
            self.error = data.error
            self.message = data.message
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      checkTagID (tagID) {
        let self = this
        this.$http.get('/student/tag_check?StudentID=' + self.student.StudentID + '&AssignedTagID=' + tagID)
          .then(function (response) {
            let data = response.data
            if (!data.error) {
              self.scannedRFID = tagID
              // self.scanning = null
              self.scanning = 0
              return
            }
            self.error = data.error
            self.message = data.message
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      updateCallScan () {
        this.$emit('update:callScan', this.RFID)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Tag.vue?6d171d06